// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/scope_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { ScopeService } from "./scope_service_pb";

/**
 * @generated from rpc inventory.v1.ScopeService.ListScopes
 */
export const listScopes = ScopeService.method.listScopes;

/**
 * @generated from rpc inventory.v1.ScopeService.GetScope
 */
export const getScope = ScopeService.method.getScope;

/**
 * @generated from rpc inventory.v1.ScopeService.CreateScope
 */
export const createScope = ScopeService.method.createScope;

/**
 * @generated from rpc inventory.v1.ScopeService.UpdateScopeDefinition
 */
export const updateScopeDefinition = ScopeService.method.updateScopeDefinition;

/**
 * @generated from rpc inventory.v1.ScopeService.DeleteScope
 */
export const deleteScope = ScopeService.method.deleteScope;

/**
 * @generated from rpc inventory.v1.ScopeService.SetScopeControls
 */
export const setScopeControls = ScopeService.method.setScopeControls;
